export default __webpack_public_path__ + "static/Blitz28 01F47567-4bc5d4311e42811b6dd556d0d9236e6b.jpg";